<template>
  <div>
    <validation-provider
      :name="$t(config.name)"
      :rules="config.rules"
      v-slot="{ errors }"
    >
      <label class="d-block">
        {{ $t(config.name) }}
      </label>
      <div v-if="!loading && showFromAlarm">
        <input type="text"
               class="form-control"
               v-model="model"
               @input="$emit('input', model)"
        />
        <p v-if="config.hint" class="mb-0 small">{{ $t(config.hint) }}</p>
      </div>
      <div v-if="!loading && !showFromAlarm">
        <v-select
          v-model="model"
          :options="itemsOptions"
          :clearable="true"
          :reduce="(val) => val.value"
          :multiple="multiple"
          @input="$emit('input', model)"
        />
        <p v-if="config.hint" class="mb-0 small">{{ $t(config.hint) }}</p>
      </div>
      <p v-else-if="loading">Loading...</p>
      <p v-if="errors" class="small text-danger">{{ errors[0] }}</p>
    </validation-provider>
  </div>
</template>

<script>
import vSelect from "vue-select";
import {ValidationProvider} from "vee-validate";
import axios from "@/libs/axios";
import store from "@/store";
import {EventBus} from "@/libs/event-bus";

export default {
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    value: Array | Object,
    multiple: Boolean | Number,
    config: {
      type: Object,
      default: () => ({})
    },
    context: Object,
    nodeConfig: Object,
  },
  data() {
    return {
      model: null,
      items: [],
      options: [],
      showFromAlarm: false,
      loading: false,
      selectedValue: null,
    };
  },
  created() {
    this.$nextTick(() => {
      this.model = this.value || null;
    });
  },
  async mounted() {
    EventBus.on("cameras:data", this.onCameraData);
    this.showFromAlarm = this.context.model.cameras === 'from_alarm';
    if (this.context.model.cameras !== 'from_alarm') {
      await this.fetchTags(this.context.model.cameras);
    }
  },
  beforeDestroy() {
    EventBus.off("cameras:data");
  },
  computed: {
    itemsOptions() {
      if (this.options.length) {
        return this.options;
      }

      this.options = [...this.items];

      return this.options;
    },

  },
  methods: {
    onCameraData(data) {
      this.showFromAlarm = data === 'from_alarm';
      this.handleCameraUpdates(data);
    },
    async fetchTags(cameraData) {
      this.items = [];

      if (!cameraData || cameraData === 'from_alarm') {
        this.loading = false;
        return;
      }

      this.loading = true;

      const idTenants = [cameraData.id_tenant];
      await store.dispatch("tenant/getDeviceTagsByTenantIds", {id_tenants: idTenants});

      this.items = store.getters["tenant/getDeviceTags"].map((item) => ({
        label: item.name,
        value: item.id,
      }));

      this.loading = false;
    },
    handleCameraUpdates(value) {
      if (value) {
        this.options = [];
        this.items = [];
        this.model = null;

        if (value !== "from_alarm") {
          this.fetchTags(value);
        }
      }
    }
  }
};
</script>

<style></style>
